import {
  faFont,
  faHashtag,
  faCheckSquare,
  faCalendar,
  faLink,
  faPaperclip,
  faCircle,
  faKey,
} from "@fortawesome/free-solid-svg-icons";

export interface FieldTypeMeta {
  value: string;
  label: string;
  labelKey: string;
  description: string;
  descriptionKey: string;
  exampleKey: string;
  icon: any;
  example: string;
}

export const FIELD_TYPES: FieldTypeMeta[] = [
  {
    value: "id",
    label: "ID",
    labelKey: "idLabel",
    description: "Unique identifier, auto-generated for each record.",
    descriptionKey: "idDesc",
    icon: faKey,
    example: "1, 2, 3, ...",
    exampleKey: "idExample",
  },
  {
    value: "string",
    label: "Text",
    labelKey: "stringLabel",
    description: "Simple short text value: name, title, label.",
    descriptionKey: "stringDesc",
    icon: faFont,
    example: "Example: John Doe",
    exampleKey: "stringExample",
  },
  {
    value: "text",
    label: "Long Text",
    labelKey: "textLabel",
    description: "Multi-line data for descriptions and notes.",
    descriptionKey: "textDesc",
    icon: faFont,
    example: "Task description in a few sentences.",
    exampleKey: "textExample",
  },
  {
    value: "password",
    label: "Password",
    labelKey: "passwordLabel",
    description: "Hidden input for confidential data.",
    descriptionKey: "passwordDesc",
    icon: faFont,
    example: "•••••••• (secured input)",
    exampleKey: "passwordExample",
  },
  {
    value: "int",
    label: "Integer",
    labelKey: "intLabel",
    description: "Whole number without fractional part.",
    descriptionKey: "intDesc",
    icon: faHashtag,
    example: "5, 42, 1000",
    exampleKey: "intExample",
  },
  {
    value: "double",
    label: "Float",
    labelKey: "doubleLabel",
    description: "Decimal number: prices, measurements, percentage.",
    descriptionKey: "doubleDesc",
    icon: faHashtag,
    example: "129.99, 3.14, 0.25",
    exampleKey: "doubleExample",
  },
  {
    value: "bigint",
    label: "Big Number",
    labelKey: "bigintLabel",
    description: "Very long integer values.",
    descriptionKey: "bigintDesc",
    icon: faHashtag,
    example: "987654321012345678",
    exampleKey: "bigintExample",
  },
  {
    value: "boolean",
    label: "Yes / No",
    labelKey: "booleanLabel",
    description: "Binary value: enabled / disabled, active / inactive.",
    descriptionKey: "booleanDesc",
    icon: faCheckSquare,
    example: "true / false (active: Yes)",
    exampleKey: "booleanExample",
  },
  {
    value: "date",
    label: "Date",
    labelKey: "dateLabel",
    description: "Calendar date without time.",
    descriptionKey: "dateDesc",
    icon: faCalendar,
    example: "2025-12-05",
    exampleKey: "dateExample",
  },
  {
    value: "datetime",
    label: "Date & Time",
    labelKey: "datetimeLabel",
    description: "Stores both date and time.",
    descriptionKey: "datetimeDesc",
    icon: faCalendar,
    example: "2025-12-05 14:33",
    exampleKey: "datetimeExample",
  },
  {
    value: "fk",
    label: "Relation (Foreign Key)",
    labelKey: "fkLabel",
    description: "Stores ID of another record.",
    descriptionKey: "fkDesc",
    icon: faLink,
    example: "user_id = 27 → table \"users\"",
    exampleKey: "fkExample",
  },
  {
    value: "file",
    label: "File",
    labelKey: "fileLabel",
    description: "Upload document, image or any attachment.",
    descriptionKey: "fileDesc",
    icon: faPaperclip,
    example: "scan.pdf, avatar.png, document.docx",
    exampleKey: "fileExample",
  },
  {
    value: "multiselect",
    label: "Multi Select",
    labelKey: "multiselectLabel",
    description: "Array of values: list of skills, tags or categories.",
    descriptionKey: "multiselectDesc",
    icon: faCircle,
    example: "[\"TypeScript\", \"React\", \"CSS\"]",
    exampleKey: "multiselectExample",
  },
  {
    value: "json",
    label: "JSON",
    labelKey: "jsonLabel",
    description: "Flexible structure for storing complex data.",
    descriptionKey: "jsonDesc",
    icon: faCircle,
    example: "{ \"width\": 120, \"height\": 80 }",
    exampleKey: "jsonExample",
  },
];